import { render, staticRenderFns } from "./ActivityLogItem.vue?vue&type=template&id=3dd7c984&scoped=true&"
import script from "./ActivityLogItem.vue?vue&type=script&lang=js&"
export * from "./ActivityLogItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogItem.vue?vue&type=style&index=0&id=3dd7c984&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7c984",
  null
  
)

export default component.exports